<!-- <mat-toolbar></mat-toolbar> -->
<!-- <mat-sidenav-container></mat-sidenav-container> -->
<!-- <mat-sidenav-content> -->
<router-outlet>
    <app-spinner></app-spinner>
    <!-- <app-dev-menu-button></app-dev-menu-button> -->
</router-outlet>
<!-- </mat-sidenav-content> -->